export interface CareerCoachReportFilterSettings {
    tmSearch: string;
    tmPractice: string[];
    tmMajor: string[];
    tmPosition: string[];
    tmOffice: string[];
    ccSearch: string;
    ccPractice: string[];
    ccMajor: string[];
    coachCapability: string[];
    ccPosition: string[];
    ccOffice: string[];
}

export function defaultCareerCoachReportFilterSettings(): CareerCoachReportFilterSettings {
    return {
        tmSearch: '',
        tmPractice: [],
        tmMajor: [],
        tmPosition: [],
        tmOffice: [],
        ccSearch: '',
        ccPractice: [],
        ccMajor: [],
        coachCapability: [],
        ccPosition: [],
        ccOffice: []
    };
}
